import LoadBatch from "../core/LoadBatch";
import F84Game from "../Game";
import { DecorationData, DecorationList } from "../game/DecorationData";

export default class LoadBatches {

    static get Boot(): LoadBatch {
        const batch = F84Game.Instance.loadBatches.get("boot");
        if (batch.assets.size == 0) {
            batch.addImages("./assets/images/temp/", {
                whiteSquare: "white-square",
                whiteCircle: "white-circle",
            });
            batch.addImages("./assets/images/loading/", {
                loadingBarBacker: "ag-photo-loading-bar-backer",
                loadingBarFill: "ag-photo-loading-bar-fill",
                loadingLogoBacker: "ag-photo-loading-logo-backer",
                splashLogo: "ag-photo-splash-ag-logo",
                splashTextBacker: "ag-photo-splash-text-backer",
                splashbg: "ag-photo-takephoto-bg"
            });
            batch.addJson("decorations", "./assets/json/decorations.json", false);
            batch.addImages("./assets/images/take-photo/", {
                leftClutter: "ag-photo-takephoto-clutter-left",
                rightClutter: "ag-photo-takephoto-clutter-right",
            });
            batch.addSpine("splash-sparkle", "./assets/animations/splash-sparkle/", "ag-photo-splash-sparkles");
        }
        return batch;
    }

    static get Global(): LoadBatch {
        const batch = F84Game.Instance.loadBatches.get("global");
        if (batch.assets.size == 0) {
            batch.addImages("./assets/images/temp/", {
                textButton: "quit-yes-no-btn",
            });

            batch.addImages("./assets/images/take-photo/ag-photo-takephoto-", {
                photoFrame: "photo-mask",
            });

            for (let i = 1; i <= 17; i++) {
                batch.addImage("takePhotoDoll" + i, "./assets/images/take-photo/ag-photo-takephoto-doll-" + i + ".png");
            }
            
            batch.addImages("./assets/images/ui/", {
                backButton: "ag-photo-ui-btn-back",
                homeBtn: "ag-photo-ui-btn-home",
                nextBtn: "ag-photo-ui-btn-next",
                soundBtnOff: "ag-photo-ui-btn-sound-off",
                soundBtnOn: "ag-photo-ui-btn-sound-on",
                undoBtn: "ag-photo-ui-btn-undo",
                confirmBtn: "ag-photo-gp-transform-btn-confirm",
                trashBtn: "ag-photo-gp-transform-btn-trash"
            });

            batch.addImages("./assets/images/take-photo/ag-photo-takephoto-", {
                takePhotoBG: "bg",
                takePhotoCorkCorner: "cork-corners",
                takePhotoHeader: "header",
                takePhotoBase: "photo-base",
                takePhotoCorners: "photo-corners",
                takePhotoGuides: "photo-guides",
                takePhotoMask: "photo-mask",
                takePhotoShadow: "photo-shadow",
                takePhotoTumbBacker: "thumb-backer",
            });

            batch.addImages("./assets/images/confirm-quit/", {
                quitBacker: "ag-photo-quit-popup-backer",
                quitCorkBacker: "ag-photo-quit-btn-cork-backer",
                noBtn: "ag-photo-quit-btn-no",
                yesBtn: "ag-photo-quit-btn-yes",
                confirmBacker: "ag-photo-takephoto-confirm-popup-base"
            });

            batch.addSounds("./assets/audio/", {
                menuMusic: "photobooth-music-loop",
                click: "generic-ui-press",
                dressupTabPress: "dressup-tab-press",
                splashPlayBtn: "splash-play-btn",
                takePhotoBtn: "take-photo-btn",
            }, ".mp3");
        }
        return batch;
    }

    static get Menu(): LoadBatch {
        const batch = F84Game.Instance.loadBatches.get("menu");
        if (batch.assets.size == 0) {
            batch.addImages("./assets/images/take-photo/", {
                waitingForCamera: "ag-photo-takephoto-waiting",
                //noCamera: "no-camera",
                spinner: "ag-photo-takephoto-waiting-spinner",
            });

            // batch.addImages("./assets/images/take-photo/ag-photo-takephoto-", {
            //     takePhotoBG: "bg",
            //     takePhotoCorkCorner: "cork-corners",
            //     takePhotoHeader: "header",
            //     takePhotoBase: "photo-base",
            //     takePhotoCorners: "photo-corners",
            //     takePhotoGuides: "photo-guides",
            //     takePhotoMask: "photo-mask",
            //     takePhotoShadow: "photo-shadow",
            //     takePhotoTumbBacker: "thumb-backer",
            // });

            batch.addImages("./assets/images/take-photo/ag-photo-ui-", {
                takePhotoArrow: "arrow",
                takePhotoBtnL: "btn-arrow-l",
                takePhotoBtnR: "btn-arrow-r",
                takePhotoBack: "btn-back",
                takePhotoButton: "btn-takephoto",
                takePhotoYourPhoto: "btn-yourphoto",
            });

            batch.addImages("./assets/images/splash/ag-photo-splash-", {
                // splashLogo: "ag-logo",
                splashBG: "bg",
                splashPlayBtn: "btn-play",
                splashDecos: "decos-flat",
                splashPhotoAddy: "photo-addy",
                splashPhotoCourtney: "photo-courtney",
                splashPhotoKaya: "photo-kaya",
                // splashTextBacker: "text-backer",
                // splashTextPhoto: "text-photo",
            });

            batch.addSpine("camera-flash", "./assets/animations/camera-flash/", "ag-photo-cameraflash");
            batch.addSpine("splash-fold", "./assets/animations/splash-fold/", "ag-photo-splash-coverturn");
        }
        return batch;
    }

    static get Gameplay(): LoadBatch {
        const batch = F84Game.Instance.loadBatches.get("gameplay");
        if (batch.assets.size == 0) {
            batch.addImages("./assets/images/temp/", {
                scrollBarBG: "game-scroll-bar",
            });

            batch.addImages("./assets/images/gameplay/", {
                gameplayBg: "ag-photo-gp-bg",
                corkBg: "ag-photo-gp-side-bg",
                divider: "ag-photo-gp-side-divider",
                transformArrow: "ag-photo-gp-transform-arrow-scale",
                rotationArrow: "ag-photo-gp-transform-arrow-rotate",
                transformCircle: "ag-photo-gp-transform-circle",
                unavailableIcon: "ag-photo-gp-thumbs-none",
                dollInUse: "ag-photo-gp-thumb-dolls-inuse",
            });

            batch.addImages("./assets/images/gameplay/decoration-menu/", {
                sideBacker: "ag-photo-gp-side-backer",
                sideInner: "ag-photo-gp-side-inner",
                sideHeader: "ag-photo-gp-side-header",
                sideGradient: "ag-photo-gp-side-inner-gradient",
                sideSlider: "ag-photo-gp-slider",
                accessoriesTabIn: "ag-photo-gp-tab-accessories-in",
                accessoriesTabOut: "ag-photo-gp-tab-accessories-out",
                dollsTabIn: "ag-photo-gp-tab-dolls-in",
                dollsTabOut: "ag-photo-gp-tab-dolls-out",
                filtersTabIn: "ag-photo-gp-tab-filters-in",
                filtersTabOut: "ag-photo-gp-tab-filters-out",
                framesTabIn: "ag-photo-gp-tab-frames-in",
                framesTabOut: "ag-photo-gp-tab-frames-out",
                stickersTabIn: "ag-photo-gp-tab-stickers-in",
                stickersTabOut: "ag-photo-gp-tab-stickers-out",
                base1: "ag-photo-gp-thumb-base1",
                base1Select: "ag-photo-gp-thumb-base1-selected",
                base2: "ag-photo-gp-thumb-base2",
                base2Select: "ag-photo-gp-thumb-base2-selected"
            });

            batch.addImages("./assets/images/recap/", {
                editBtn: "ag-photo-recap-btn-edit",
                newBtn: "ag-photo-recap-btn-new",
                saveBtn: "ag-photo-recap-btn-save",
                recapHeader: "ag-photo-recap-header",
                recapLogoDeco: "ag-photo-recap-logo-deco",
                confetti1: "ag-photo-recap-confetti1",
                confetti2: "ag-photo-recap-confetti2",
                confetti3: "ag-photo-recap-confetti3",
                confetti4: "ag-photo-recap-confetti4",
                confetti5: "ag-photo-recap-confetti5",
                confetti6: "ag-photo-recap-confetti6",
                confetti7: "ag-photo-recap-confetti7",
                confetti8: "ag-photo-recap-confetti8",
            });

            const path = `./assets/images/decorations/`;
            const decorations = F84Game.Instance.cache.json.get("decorations") as DecorationList;
            for (const key of Object.keys(decorations)) {
                const list = (<Record<string, DecorationData[]>>decorations)[key];
                for (let i = 0; i < list.length; i++) {
                    const data = list[i];
                    if(data.disable == true) continue;
                    if (data.path) batch.addImage(data.id, `${path}${key}/${data.path}.png`);
                    if (data.thumbPath) batch.addImage(data.thumb, `${path}${key}/${data.thumbPath}.png`);
                }
            }
        }
        return batch;
    }
}
